import * as React from "react";
import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== "progressColor",
})(({ theme, progressColor }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", { backgroundColor: theme.palette.grey[800] }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: progressColor || "#1a90ff",
    ...theme.applyStyles("dark", { backgroundColor: progressColor || "#308fe8" }),
  },
}));

const BorderLinearProgressBar = ({ value, progressColor, ...props }) => {
  return <BorderLinearProgress variant="determinate" value={value} progressColor={progressColor} {...props} />;
};

export default BorderLinearProgressBar;
